module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-other_3.7638cfae.png";